module.exports = {"Description":"NC : 988NN","RedundantCharacters":" -","ValidationRegex":"^988[0-9]{2}$","TestData":{"Valid":["98800","98890"],"Invalid":["9882","988999","98990","098890"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/NC.json
// module id = 4476
// module chunks = 11